<div class="modal-content p-3">
  <div class="modal-header">
    <h5 class="modal-title w-100 pe-2" id="myModalLabel">{{ userPersistenceService.generalTranslation.Forgotpwd }}</h5>
  </div>

  <div class="modal-body">
    @if (!emailSent) {
      <div>
        {{ userPersistenceService.generalTranslation.Instruction }}
      </div>
    }
    @if (emailSent) {
      <div>
        <div class="pb-2">
          <strong>
            {{userPersistenceService.generalTranslation.ResetInst }}
          </strong>
          <div class="mt-2">
            <button type="submit" mat-raised-button color="primary" class="ms-0 text-uppercase pt-2 pb-2 no-shadow rounded" (click)="openLogin()">
              {{userPersistenceService.generalTranslation.SignIn}}
            </button>
          </div>
        </div>
      </div>
    }
    @if (!emailSent) {
      <div>
        <ifc-input-field name="email" [form]="form" [schema]="schema" maxlength="100"></ifc-input-field>
      </div>
    }
    <div class="pt-2">
      <span class="font-weight-bold">{{userPersistenceService.generalTranslation.EmailTextNote}}</span>
      <span>{{userPersistenceService.generalTranslation.EmailNote}}</span>
    </div>
  </div>
  @if (!emailSent) {
    <div class="modal-footer mt-3">
      <div class="col-md-12 border-top text-end pt-4 pe-0 pb-0 ps-0 forgot-password-actions">
        <button type="button" mat-stroked-button color="primary" class="btn text-uppercase body2 mt-0 mb-0 pt-2 pb-2 no-shadow rounded btn-min-width"
          aria-label="Close" (click)="onCancelClick()">
          {{userPersistenceService.generalTranslation.Cancel}}
        </button>
        <button type="button" mat-raised-button color="primary" class="relative btn text-uppercase body2 mt-0 mb-0 pt-2 pb-2 no-shadow rounded me-0 ms-0 btn-min-width"
          (click)="onSendClick()">
          {{userPersistenceService.generalTranslation.Send}}
        </button>
      </div>
    </div>
  }
</div>
